import { InMemoryCache } from '@apollo/client/cache'
import introspectionResult from 'graphql/fragment-types.generated.json'

const cache = new InMemoryCache({
  possibleTypes: introspectionResult.possibleTypes,
})

export default cache
